export default {
  mounted() {
    if (window && window.DD_RUM) {
      this.logAkamaiExperienceName();
    }
  },
  methods: {
    logAkamaiExperienceName() {
      if (this.testData) {
        const {
          AkamaiPolicySegmentName,
          SiteLocation,
          TestName,
          Variation,
          Date,
        } = this.testData || {};
        const uniqueId = `${AkamaiPolicySegmentName}:${SiteLocation}|${TestName}:${Variation}:${Date}`;
        window?.DD_RUM?.addFeatureFlagEvaluation('akamai-experience-name', uniqueId);
      }
    },
  },
};
